import React, { useCallback } from 'react';

import { useNavigate } from 'react-router-dom';

import Typography from 'components-new/typography/typography';
import Button from 'components-new/button/button';

import { createLocale } from 'locales';

import FreelancerSignUpPageContainer from '../components/freelancer-sign-up-page-container';
import freelancerRoutes from '../freelancer-routes';

const freelancerLandingLocalize = createLocale('freelancerLandingLocales');
const globalLocalize = createLocale('global');

const Landing = (): JSX.Element => {
  const navigate = useNavigate();

  const navigateToLoginPage = useCallback(() => {
    navigate(`../${freelancerRoutes.login.path}`);
  }, [navigate]);

  const navigateToSignUpPage = useCallback(() => {
    navigate(`../${freelancerRoutes.signUp.path}`);
  }, [navigate]);

  return (
    <FreelancerSignUpPageContainer
      showHeader
      headerTitle={freelancerLandingLocalize('title')}
      className="flex flex-col items-center"
    >
      <img
        className="mt-auto"
        src={`${window.STATIC_URL}assets/tadaah-logo-2024.svg`}
        height="75px"
        width="234px"
        alt="logo"
      />
      <Typography as="p" variant="body-large-bold" className="mt-7">
        {freelancerLandingLocalize('childcareFreelancers')}
      </Typography>
      <img
        className="mt-4"
        src={`${window.STATIC_URL}assets/sign-up-landing-banner.png`}
        height="320px"
        width="320px"
        alt="banner"
      />
      <Button
        label={globalLocalize('signUp')}
        variant="secondary"
        className="w-full mt-6 justify-center"
        onClick={navigateToSignUpPage}
      />
      <Button
        label={globalLocalize('login')}
        variant="primary"
        className="w-full mt-8 justify-center mb-auto"
        onClick={navigateToLoginPage}
      />
    </FreelancerSignUpPageContainer>
  );
};

export default Landing;
